export default "__VITE_ASSET__Bgn90eF2__"